const tracker = 'https://stg.contessa.io/tracker'
const api = 'https://stg.contessa.io/api/tracker/odata'
const idp = 'https://stg.contessa.io/idp'
const smapi = 'https://stg.contessa.io/api/sm'
const cmapi = 'https://stg.contessa.io/api/exchange/claimsfrontend'
const rmapi = 'https://stg.contessa.io/api/exchange/remittancemanagement'
const userManagementUrl = 'https://stg.contessa.io/user-management/users'
const blobapi = 'https://stg.contessa.io/api/blob'
const reactAppUrl = 'https://stg.contessa.io/react'
const caseloadUrl = reactAppUrl + '/caseload'

export const environment = {
  serviceWorkerEnabled: true,
  production: true,
  pmroot: tracker,
  apiroot: api,
  smapiroot: smapi,
  tmapiroot: cmapi,
  rmapiroot: rmapi,
  blobapiroot: blobapi,
  userManagementUrl,
  reactAppUrl,
  caseloadUrl,
  timeoutIntervalInMilliseconds: 1000 * 870,
  outputOIDCDebugLogs: false,
  gatherMetrics: true,
  auth: {
    authority: idp,
    client_id: 'chi-ui',
    redirect_uri: 'https://stg.contessa.io/login',
    post_logout_redirect_uri: 'https://stg.contessa.io/logout',
    response_type: 'code',
    scope:
      'openid profile email offline_access notification.api tracker.api graphql.api ' +
      'sm.api blob.api exchange.claims.frontend.api exchange.remittance.api IdentityServerApi',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: 'https://stg.contessa.io/assets/oidc/refresh.html'
  }
}
